/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Psm_LabelInputs */



/**
* | output |
* | --- |
* | "Text Detection Mode" |
*
* @param {Ocr_Psm_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_psm_label = /** @type {((inputs?: Ocr_Psm_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Psm_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mode de détection de texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Texterkennungsmodus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modalità di rilevamento del testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Режим распознавания текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modo de detección de texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本检测模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキスト検出モード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट डिटेक्शन मोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modo de detecção de texto")
	return /** @type {LocalizedString} */ ("Text Detection Mode")
});